<template>
    <div>
        <AddressListItem
                v-for="(address, k) in addressList"
                :address="address"
                :key="k"
                @onDeleteAddress="onDeleteAddress($event)"
                @onEditAddress="onEditAddress($event)"
        ></AddressListItem>

        <div v-if="isLoaded && addressList.length == 0">
            <div class="w-full">
                <div class="w-full flex mt-24">
                    <img class="m-auto pb-4" src="../../../../assets/icon/ic-empty-address.svg"/>
                </div>
                <div class="text-14 lg:text-16 text-a-brown-9f8273 text-center">
                     There is no address yet.
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from '@/mixin/ModalMixin';
import AddressListItem from "./AddressListItem.vue";
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";

/**
 * @event onDeleteAddress
 * @event onEditAddress
 */
export default {
    name: "AddressList",
    inject: ['DeliveryStore'],
    mixins: [ErrorApiMixin, ModalMixin],
    components: {
        AddressListItem,
    },
    data: function() {
        return {
            addressList: [],
            isLoaded: false,
        };
    },
    mounted: function() {
        this.getAddressList();
    },
    methods: {
        getAddressList: function() {
            BzbsAddressList.apiGetAddressList().subscribe((addressList) => {
                this.addressList = addressList;
                this.isLoaded = true;
                this.$emit('onLoaded');
            }, (err) => {
                this.isLoaded = true;
                this.errorApi(err);
                this.$emit('onLoaded');
            });
        },

        onDeleteAddress: function(address) {
            this.$emit('onDeleteAddress', address);
        },
        onEditAddress: function(address) {
            this.DeliveryStore.methods.initAddress();
            this.DeliveryStore.state.address = address;

            this.$emit('onEditAddress', address);
        },
        getList: function() {
            return this.addressList;
        }
    },
}
</script>
